import { Button, Checkbox, Tag } from "antd";
import { FormattedMessage } from "react-intl";
import Icon from "../Icon/Icon";
import Popup from "../Popup/Popup";
import Spinner from "../Spinner/Spinner";
import { Article, Props } from "./OrcidArticleSelection.model";
import styles from './OrcidArticleSelection.module.scss';
import { useOrcidArticleSelection } from "./useOrcidArticleSelection";

const OrcidArticleSelection = ({ orcidId, onClose }: Props) => {

	const {addArticles, areAllArticlesSelected, onSelectArticle, onSelectAllArticles, isArticleSelected, state } = useOrcidArticleSelection({ orcidId, onClose });
	const { selectedArticles, orcidArticles, spinning } = state;
	const renderChips = (chips: string[]) => {
		return chips.map((field: string, index: number) => (<Tag
			key={`${field}${index}`}
			style={{
				border: 'none',
				textTransform: 'uppercase'
			}}>{field}</Tag>))
	}
	
	const renderArticle = (article: Article, index: number) => {
		return <div className={styles.article} key={`${article.title}${index}`} onClick={onSelectArticle.bind(null, article)}>
					<div className={styles.icon}>
						<Icon name="file-alt" color="white" width="12px" height="16px" />
					</div>
					<div className={styles.articleContent}>
						<h2>{article.title}</h2>
						<i>{article.authors.map((author: string, index: number) => <span key={`author${index}`}>{author}{index !== article.authors.length - 1 && ', '}</span>)}</i> <br />
						<div>{renderChips(article.tags)}</div>
						<b>{article.publishedIn}, {article.publishingYear}</b>
						<p>{article.description}</p>
						<div><a href={article.link} rel="noreferrer" target="_blank"><FormattedMessage id="userLabels.seeArticle" /></a></div>
			</div>
			<div>
				<Checkbox checked={isArticleSelected(article)} onClick={onSelectArticle.bind(null, article)}></Checkbox>
			</div>
			
		</div>
	}

	return <Popup onClose={onClose}
		actions={<>
			<Button type="default" onClick={onClose} size="large">
				<FormattedMessage id="buttons.cancel"/>
			</Button>
			<Button type="primary" size="large" onClick={addArticles}>
				<FormattedMessage id="orcid.addArticles" values={{ number: selectedArticles.length }} />
			</Button></>}
		title={{ action: '', target: 'importFromOrcid' }}
		size="extra-large"
		height="full-height">
		<div className={styles.popupContent}>
			<Spinner spinning={spinning} fixed={false}/>
			<div className={styles.header}>
				<b>{orcidArticles?.count}</b>
				{' '}
				<FormattedMessage id="orcid.results" />
					{' '}
				<span className={styles.green}><FormattedMessage id="orcid.account" /></span>
				
				<div className={styles.actions}>
					<label><FormattedMessage id="formLabels.selectAll" /></label>
					<Checkbox checked={areAllArticlesSelected()} onClick={onSelectAllArticles}>
				</Checkbox></div>
							
			</div>
			<div className={styles.articles}>
				{orcidArticles?.articles?.map((article: Article, index: number)=> renderArticle(article, index))}
				</div>
					</div>
				</Popup>
	
}

export default OrcidArticleSelection;